import { Helmet } from 'react-helmet';
import seoMetaData from '../../Include/Seo/seoMetaData';
import Navbar from '../../Include/Navbar/Navbar';
import Footer from '../../Include/Footer/Footer';
import Breadcrumb from './Data/Breadcrumb';
import breadcrumbData from './Data/breadcrumbData';
import Contact from '../Home/Contact';
import Services from './Data/Services';
import servicesData from './Data/servicesData';
import TechCTASection from './Data/HireSection';
// import OurExpertise from './Data/OurExpertise';
import Whyus from './Data/Whyus';
import whyData from './Data/whyusData';

export default function Index() {
  const { title, description } = seoMetaData.nodejs;
  return (
    <>
     <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href="https://www.cloudkode.com/services/nodejs-development" />
        <script type="application/ld+json">
{`
  {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "url": "https://cloudkodeform.com/technology/nodejs",
  "name": "Node.js Development Services",
  "description": "CloudKodeForm delivers scalable and high-performance backend solutions with expert Node.js development services. Build real-time, event-driven applications with our skilled team.",
  "inLanguage": "en",
  "publisher": {
    "@type": "Organization",
    "name": "CloudKodeForm",
    "url": "https://cloudkodeform.com",
    "logo": {
      "@type": "ImageObject",
      "name": "CloudKodeForm",
      "url": "https://cloudkodeform.com/static/media/logo_white.210461645b0e9241d56c926ddacdd810.svg"
    }
  },
  "mainEntity": {
    "@type": "Service",
    "name": "Node.js Development",
    "serviceType": "Backend Web Development",
    "provider": {
      "@type": "Organization",
      "name": "CloudKodeForm",
      "url": "https://cloudkodeform.com"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Global"
    }
  },
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://cloudkodeform.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Technology",
        "item": "https://cloudkodeform.com/technology"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Node.js",
        "item": "https://cloudkodeform.com/technology/nodejs"
      }
    ]
  }
}
`}
</script>

      </Helmet>
   <Navbar />
   <Breadcrumb data={breadcrumbData.nodejs} />
   <Services data={servicesData.nodejs} />
   <TechCTASection/>
   {/* <OurExpertise/> */}
   <Whyus data={whyData.nodejs} />
   <Contact sectionId="nidejs-page-contact"/>
   <Footer/>
   </>
  )
}
